module.exports = {
      id: "mail-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b9c19baa.svg#mail-usage",
      toString: function () {
        return this.url;
      }
    }